export default "__VITE_ASSET__CRyIZ4jw__"